"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = void 0;
const common_1 = require("@finley-technologies/common");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const conversionUtils_1 = require("../../conversionUtils");
const operationConvertors_1 = require("../../operationConvertors");
const types_1 = require("./types");
const uinode_1 = require("./uinode");
// converts intermediate records to 1 or more UI nodes.
const intermediateToUINodes = (tape) => {
    (0, common_1.finleyAssert)(uinode_1.file_generatedRepaymentTape.isIntermediateRecord(tape), `intermediateToUINodes: tape is not an ${types_1.artifactType}`);
    const { id, loanProductSlug, artifactSlug, creditFacilitySlug, configuration, } = tape;
    const { rawExternalReceivableIdField, rawRepaymentTapeArtifactSlug, generatedLoanTapeArtifactSlug, externalReceivableIdField: _unusedExternalIdField, ...remainingConfiguration } = configuration;
    const tapeNode = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug,
            loanProductSlug,
            creditFacilitySlug,
            rawExternalReceivableIdField,
            rawRepaymentTapeArtifactSlug,
            generatedLoanTapeArtifactSlug,
        },
    };
    const operationNode = (0, operationConvertors_1.taskToOperationNode)({
        task: remainingConfiguration,
    });
    return {
        operationNode,
        tapeNode,
    };
};
// converts UI nodes to intermediate records.
// returns new record and old record ids to be replaced.
const uiNodesToIntermediate = (params) => {
    const { artifactDocumentId, node, graph } = params;
    (0, common_1.finleyAssert)(uinode_1.file_generatedRepaymentTape.isNode(node), `uiNodesToIntermediate: node is not a ${types_1.artifactType} node: ${node.metadata.tapeBuilderNodeType}`);
    const { tapeBuilderNodeId } = node.metadata;
    const { artifactSlug, loanProductSlug, creditFacilitySlug, rawExternalReceivableIdField, rawRepaymentTapeArtifactSlug, generatedLoanTapeArtifactSlug, } = node.configuration;
    const { operationNode, task: configuration } = (0, conversionUtils_1.getNativeOperationTask)({
        node,
        graph,
    });
    const record = {
        id: tapeBuilderNodeId,
        artifactDocumentId,
        type: types_1.artifactType,
        artifactSlug,
        creditFacilitySlug,
        loanProductSlug,
        externalFilename: null,
        configuration: {
            ...configuration,
            rawExternalReceivableIdField,
            externalReceivableIdField: (0, tape_sanitizer_1.getSanitizedFieldName)(rawExternalReceivableIdField, true),
            rawRepaymentTapeArtifactSlug,
            generatedLoanTapeArtifactSlug,
        },
    };
    return {
        record,
        operationNode,
    };
};
exports.converter = {
    artifactType: types_1.artifactType,
    nodeType: types_1.nodeType,
    intermediateToUINodes,
    uiNodesToIntermediate,
};
//# sourceMappingURL=converter.js.map